<div class="member-section" [class.member-section--info]="canAddMembers || showRoles">
  @if (canAddMembers || showRoles) {
  <p class="member-section__title">{{ 'NGX-MESSAGING.LIST-MEMBERS.channelMembers' | translate }}</p>
  } @if (selectedChannel()?.member?.role === ChannelRoles.ADMIN && canAddMembers) {
  <button type="button" class="member-add" (click)="openAddModal()">
    <mat-icon svgIcon="add_person"></mat-icon>
    <span>{{ 'NGX-MESSAGING.addParticipant' | translate }}</span>
  </button>
  }

  <div
    class="member-list"
    [ngStyle]="{ 'max-height': listHeight }"
    infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="20"
    [infiniteScrollContainer]="'.member-list'"
    (scrolled)="nextPage()"
    [fromRoot]="true">
    @if (!isLoadingAllCheck && !isLoadingAllMembers) { @for (member of members; track member.uid) {
    <div class="member-list__items">
      <messaging-avatar
        [ngStyle]="{ cursor: member?.profileImageURL ? 'pointer' : 'default' }"
        (click)="imagesService.openPhoto($safeNavigationMigration(member?.profileImageURL) ?? '', undefined, false)"
        [src]="$safeNavigationMigration(member?.profileImageURL)"
        [name]="$safeNavigationMigration(member?.displayName)"
        [initialsSize]="2"
        size="32">
      </messaging-avatar>
      <div class="member-list__text">
        <div class="member-list__text__name">
          <p>{{ member.displayName }}</p>
          @if (showRoles) {
          <span class="member-list__text__name__rol">{{
            'NGX-MESSAGING.LIST-MEMBERS.' + member.role | translate | shortName
          }}</span>
          }
        </div>
        <div class="member-list__text__action">
          @if (selectedChannel()?.member?.role === ChannelRoles.ADMIN && showRoles) {
          <button type="button" class="member-list__more" [matMenuTriggerFor]="menuMembers">
            <mat-icon svgIcon="more_vert"></mat-icon>
          </button>
          }
          <mat-menu #menuMembers>
            @if (canDelete && member?.role !== 'ADMIN') {
            <button mat-menu-item (click)="deleteMember(member)">
              {{ 'NGX-MESSAGING.deleteMember' | translate }}
            </button>
            } @for (rol of rols; track rol.value) {
            <button mat-menu-item (click)="changeRole(member, rol)">
              {{ 'NGX-MESSAGING.changeRoleTo' | translate }} {{ 'NGX-MESSAGING.LIST-MEMBERS.' + rol.name | translate }}
            </button>
            }
          </mat-menu>
          @if (showChecks) {
          <mat-checkbox (change)="selectMember(member)" [checked]="isMemberSelected(member)"></mat-checkbox>
          }
        </div>
      </div>
    </div>
    } } @if (isLoadingNewMembers || isLoadingAllMembers) {
    <div class="loading-members">{{ 'NGX-MESSAGING.loadingMembers' | translate }}</div>
    }
  </div>
</div>
